import {defineToolRegistryManifest} from '../../types/base-tool-types';
import {z} from 'zod';
import dedent from 'dedent';
import {elementIdSchema} from '../../schemas';

const toolName = 'get-form-input-type' as const;

const argumentZod = z.object({
  elementId: elementIdSchema.describe(
    'The ID of the FormTextInput element to get the input type from. Only works with FormTextInput elements.'
  ),
});

export const getFormInputTypeTool = defineToolRegistryManifest({
  id: toolName,
  prettyName: 'Get form input type',
  llmTool: {
    name: toolName,
    description: dedent`
      Retrieve the HTML input type of a FormTextInput element. Returns the current
      input type which can be 'text', 'email', 'password', 'tel', 'number', 'url',
      or null if not found. The input type determines how the browser handles the
      input field (validation, keyboard, formatting). Only works with FormTextInput
      elements.`,
    inputSchema: argumentZod,
  },
  type: 'designer',
  confirmBeforeExecuting: false, // Read-only operation
  timeout: 30000, // 30 seconds for retrieving input type
});
